// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumb_breadcrumb__Q3+Tr"};